import { useEffect, useState, useRef } from "react";

/**
 * Live cost meter: ticks a smooth interpolation while streaming, then locks to final.
 * Props:
 *   live (bool): actively streaming
 *   estimate (number): current best-guess USD for output-so-far
 *   final (number|null): locked USD once done
 */
export default function LiveCostMeter({ live, estimate, final }) {
  const [display, setDisplay] = useState(0);
  const raf = useRef(null);
  const target = final ?? estimate ?? 0;

  useEffect(() => {
    let start = performance.now();
    const from = display;
    const dur = 300;
    function tick(t) {
      const p = Math.min(1, (t - start) / dur);
      setDisplay(from + (target - from) * p);
      if (p < 1) raf.current = requestAnimationFrame(tick);
    }
    raf.current = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf.current);
    // eslint-disable-next-line
  }, [target]);

  const active = live && final == null;
  const cls = active ? "sage-meter-live animate-meter-pulse" : "sage-meter-idle";
  return (
    <div
      data-testid="live-cost-meter"
      className="border border-sage-border bg-sage-elevated px-3 py-2 font-mono tabular-nums text-sm inline-flex items-center gap-3"
    >
      <span className="text-xs uppercase tracking-[0.1em] text-sage-muted">Cost</span>
      <span className={cls} data-testid="live-cost-meter-value">
        ${display.toFixed(6)}
      </span>
      <span className="text-xs text-sage-faint">
        {active ? "TICKING" : final != null ? "LOCKED" : "IDLE"}
      </span>
    </div>
  );
}
